module.exports = __webpack_public_path__ + "media/images/top-1-2777e3dcbc27b49e0c3f1d336e5c4dc7.png";